const DEFAULT_OPTIONS = {
  timeout: 3000,
  position: 'bottom-right'
}

let stylesInjected = false
let container = null

function injectStyles() {
  if (stylesInjected || typeof document === 'undefined') return
  const style = document.createElement('style')
  style.id = 'mf-toast-styles'
  style.textContent = `
    .mf-toast-stack {
      position: fixed;
      z-index: 3000;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: min(420px, calc(100vw - 24px));
      pointer-events: none;
    }
    .mf-toast-stack[data-position="bottom-right"] { right: 12px; bottom: 12px; }
    .mf-toast-stack[data-position="bottom-left"] { left: 12px; bottom: 12px; }
    .mf-toast-stack[data-position="top-right"] { right: 12px; top: 12px; }
    .mf-toast-stack[data-position="top-left"] { left: 12px; top: 12px; }
    .mf-toast-stack[data-position="top-center"] {
      left: 50%; top: 12px; transform: translateX(-50%);
    }
    .mf-toast-stack[data-position="bottom-center"] {
      left: 50%; bottom: 12px; transform: translateX(-50%);
    }
    .mf-toast {
      pointer-events: auto;
      border-radius: 12px;
      padding: 12px 14px;
      color: #fff;
      box-shadow: 0 12px 28px rgba(31, 41, 55, 0.22);
      font-size: 0.95rem;
      line-height: 1.45;
      border: 1px solid rgba(255, 255, 255, 0.18);
      opacity: 0;
      transform: translateY(8px);
      transition: opacity 0.18s ease, transform 0.18s ease;
      white-space: pre-wrap;
      word-break: break-word;
    }
    .mf-toast.is-visible {
      opacity: 1;
      transform: translateY(0);
    }
    .mf-toast--default { background: #334155; }
    .mf-toast--success { background: #15803d; }
    .mf-toast--error { background: #b91c1c; }
    .mf-toast--info { background: #0369a1; }
    .mf-toast--warning { background: #b45309; }
  `
  document.head.appendChild(style)
  stylesInjected = true
}

function normalizePosition(position, fallback) {
  const allowed = new Set([
    'bottom-right',
    'bottom-left',
    'top-right',
    'top-left',
    'top-center',
    'bottom-center'
  ])
  return allowed.has(position) ? position : fallback
}

function getContainer(position) {
  if (typeof document === 'undefined') return null
  injectStyles()
  if (!container || !document.body.contains(container)) {
    container = document.createElement('div')
    container.className = 'mf-toast-stack'
    document.body.appendChild(container)
  }
  container.dataset.position = position
  return container
}

function showToast(type, message, options = {}, fallbackOptions = DEFAULT_OPTIONS) {
  if (typeof document === 'undefined') return undefined

  const timeout = options.duration && !options.timeout ? options.duration : (options.timeout ?? fallbackOptions.timeout)
  const position = normalizePosition(options.position, fallbackOptions.position)
  const mount = getContainer(position)
  if (!mount) return undefined

  const toast = document.createElement('div')
  toast.className = `mf-toast mf-toast--${type}`
  toast.textContent = String(message ?? '')
  mount.appendChild(toast)

  requestAnimationFrame(() => {
    toast.classList.add('is-visible')
  })

  const dispose = () => {
    toast.classList.remove('is-visible')
    window.setTimeout(() => {
      toast.remove()
      if (mount.childElementCount === 0) {
        mount.remove()
        container = null
      }
    }, 180)
  }

  if (timeout !== false && timeout !== 0) {
    window.setTimeout(dispose, Number(timeout) || fallbackOptions.timeout)
  }

  return { dismiss: dispose }
}

export function installToastedCompat(app, options = {}) {
  const mergedOptions = { ...DEFAULT_OPTIONS, ...options }

  const toasted = {
    show(message, opts = {}) {
      return showToast('default', message, opts, mergedOptions)
    },
    success(message, opts = {}) {
      return showToast('success', message, opts, mergedOptions)
    },
    error(message, opts = {}) {
      return showToast('error', message, opts, mergedOptions)
    },
    info(message, opts = {}) {
      return showToast('info', message, opts, mergedOptions)
    },
    warning(message, opts = {}) {
      return showToast('warning', message, opts, mergedOptions)
    }
  }

  app.config.globalProperties.$toasted = toasted
  return toasted
}
